import { render } from "./CardsIcon.vue?vue&type=template&id=37236cf1"
import script from "./CardsIcon.vue?vue&type=script&lang=js"
export * from "./CardsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script